import { useApplyFacet } from '@components/sort-and-filter/hooks/use-apply-facet';
import useTrackFilterVendors from '@hooks/useTrackFilterVendors';
import { useAppSelector } from '@redux/hooks';
import { useAtomValue } from 'jotai';
import React from 'react';
import { desiredVenueSettingAtom, guestCapacityAtom } from '../atoms';
import { quickFilterTracking } from '../helpers';
import { useQuickFilters } from '../hooks/use-quick-filters';
import { QuickFilter } from './quick-filter';

export const QuickFilters = () => {
	const { isInQuickFilters } = useQuickFilters();
	const desiredVenueSetting = useAtomValue(desiredVenueSettingAtom);
	const guestCapacity = useAtomValue(guestCapacityAtom);
	const applyFacet = useApplyFacet();
	const category = useAppSelector((state) => state.category);
	const location = useAppSelector((state) => state.location);

	const [trackVendors] = useTrackFilterVendors({
		categoryCode: category.code,
		categoryName: category.name,
		displayMarketCode: location.marketCode,
		location,
		sourcePage: 'category results',
		sourceContent: 'quick_filters',
	});

	if (!isInQuickFilters) {
		return null;
	}
	return (
		<>
			{guestCapacity && (
				<QuickFilter
					label={guestCapacity.label}
					onClick={() => {
						applyFacet(guestCapacity.facetId);
						quickFilterTracking(
							guestCapacity.facetId,
							guestCapacity.label,
							'guest_capacity',
							trackVendors,
						);
					}}
				/>
			)}
			{desiredVenueSetting.map(({ label, facetId }) => (
				<QuickFilter
					key={facetId}
					label={label}
					onClick={() => {
						applyFacet(facetId);
						quickFilterTracking(facetId, label, 'settings', trackVendors);
					}}
				/>
			))}
		</>
	);
};
